<mat-nav-list>
  <div class="logo">
    <img src="assets/images/logo.png" alt="" />
  </div>
  <div class="user">
    <img src="assets/icons/userman.svg" alt="" />
    <div class="details">
      <div class="name">{{ name }}</div>
      <div class="id">Role: {{ role }}</div>
    </div>
  </div>
  <div class="line"></div>
  <div class="links">
    <mat-accordion *ngIf="role == 'Administrator'">
      <mat-expansion-panel hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <img
              class="icon"
              src="assets/icons/Modules/settings.svg"
              alt="not"
            />
            <span>Admin</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="allLink">
          <a (click)="openUser()">Users </a>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <a
      class="link"
      [routerLink]="['/profile']"
      [routerLinkActiveOptions]="{ exact: true }"
      routerLinkActive="active"
    >
      <img class="icon" src="assets/icons/Modules/dashboard.svg" alt="" />
      <span>My Dashboard</span>
    </a>
    <!-- <a
      class="link"
      [routerLink]="['/share-holdings']"
      [routerLinkActiveOptions]="{ exact: true }"
      routerLinkActive="active"
    >
      <img src="assets/icons/shareholder.svg" alt="" />
      <span>Shareholdings</span>
    </a> -->
    <mat-accordion *ngIf="role == 'Administrator' || role == 'Front Desk'">
      <mat-expansion-panel hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <img class="icon" src="assets/icons/Modules/settings.svg" alt="" />
            <span>Setup</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="allLink">
          <a
            (click)="openTitle()"
            *ngIf="role == 'Administrator' || role == 'Front Desk'"
            >Title
          </a>
          <a (click)="opendrop()" *ngIf="role == 'Administrator'"
            >Dropdown / Values
          </a>
          <a (click)="openVoucher()" *ngIf="role == 'Administrator'">Voucher</a>
          <a (click)="openCity()" *ngIf="role == 'Administrator'">City </a>
          <a (click)="openState()" *ngIf="role == 'Administrator'">State</a>
          <a (click)="openCountry()" *ngIf="role == 'Administrator'">Country</a>
          <a (click)="openBank()" *ngIf="role == 'Administrator'">Bank</a>
          <a (click)="openCard()" *ngIf="role == 'Administrator'">Card Type</a>
          <a (click)="openCategory()" *ngIf="role == 'Administrator'"
            >Cartegory</a
          >
          <a (click)="openEmployee()" *ngIf="role == 'Administrator'"
            >Employee</a
          >
          <a (click)="openCompany()" *ngIf="role == 'Administrator'">Company</a>
          <a (click)="openBranch()" *ngIf="role == 'Administrator'">Branch</a>
          <a (click)="openDept()" *ngIf="role == 'Administrator'">Department</a>
          <a (click)="openSub()" *ngIf="role == 'Administrator'"
            >Sub Department</a
          >
          <a (click)="openSpecial()" *ngIf="role == 'Administrator'"
            >Specialazation</a
          >
          <a (click)="openSoc()" *ngIf="role == 'Administrator'">SOC</a>
          <a (click)="openUom()" *ngIf="role == 'Administrator'">UOM</a>
          <a
            (click)="openItem()"
            *ngIf="role == 'Administrator' || role == 'Front Desk'"
            >Item</a
          >
          <a
            (click)="openRefDr()"
            *ngIf="role == 'Administrator' || role == 'Front Desk'"
            >Referral Dr</a
          >
          <a (click)="openGroups()" *ngIf="role == 'Administrator'">Groups</a>
          <a (click)="openAloc()" *ngIf="role == 'Administrator'"
            >Alloted SOC</a
          >
          <a (click)="openOpd()" *ngIf="role == 'Administrator'">OPD</a>
          <a (click)="openNational()" *ngIf="role == 'Administrator'"
            >National</a
          >
          <a (click)="openSale()" *ngIf="role == 'Administrator'">Sales Card</a>
          <a (click)="openDetail()" *ngIf="role == 'Administrator'"
            >OPD Detail</a
          >
          <a (click)="openSetup()" *ngIf="role == 'Administrator'">Setup</a>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion
      *ngIf="role == 'self-service user' || role == 'self-service consultant'"
    >
      <mat-expansion-panel hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <img
              class="icon"
              src="assets/icons/Modules/settings.svg"
              alt="not"
            />
            <span>Self Service</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="allLink">
          <a (click)="openPointment()" *ngIf="role == 'self-service user'"
            >Appointments
          </a>
          <a (click)="bookApointment()" *ngIf="role == 'self-service user'"
            >Book Appointments
          </a>
          <a
            [routerLink]="['/online-finalise']"
            *ngIf="role == 'self-service consultant'"
            >Result Finalize</a
          >
          <a
            [routerLink]="['/online-view-result']"
            *ngIf="role == 'self-service user'"
            >View Result</a
          >
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion *ngIf="role == 'Administrator' || role == 'Lab Scientist'">
      <mat-expansion-panel hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <img
              class="icon"
              src="assets/icons/Modules/promotion.svg"
              alt="not"
            />
            <span>Communication</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="allLink">
          <a (click)="openLocalPointment()" *ngIf="role == 'Administrator'"
            >Appointments
          </a>
          <a [routerLink]="['/email']" *ngIf="role == 'Administrator'"
            >Email / SMS</a
          >
          <!-- <a [routerLink]="['/sms']" *ngIf="role == 'Administrator'">SMS</a> -->
          <a
            [routerLink]="['/result']"
            *ngIf="role == 'Administrator' || role == 'Lab Scientist'"
            >Result</a
          >
          <a
            [routerLink]="['/ft-single-result']"
            *ngIf="role == 'Administrator'"
            >FT Single Result (OBS)</a
          >
          <a [routerLink]="['/ft-twin-result']" *ngIf="role == 'Administrator'"
            >FT Twin Result (OBS)</a
          >
          <a
            [routerLink]="['/ft-triplet-result']"
            *ngIf="role == 'Administrator'"
            >FT Triplets Result (OBS)</a
          >
          <a
            [routerLink]="['/second-trimester-result']"
            *ngIf="role == 'Administrator'"
            >ST Result (OBS)</a
          >
          <a
            [routerLink]="['/third-trimester-result']"
            *ngIf="role == 'Administrator'"
            >TT Result (OBS)</a
          >
          <a [routerLink]="['/receipt']" *ngIf="role == 'Administrator'"
            >Receipt</a
          >
          <a [routerLink]="['/file']" *ngIf="role == 'Administrator'">File</a>
          <a [routerLink]="['/log']" *ngIf="role == 'Administrator'">Log</a>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion
      *ngIf="
        role == 'Administrator' ||
        role == 'Front Desk' ||
        role == 'Scan' ||
        role == 'X-ray' ||
        role == 'Cashier' ||
        role == 'Lab Scientist' ||
        role == 'Lab Supervisor' ||
        role == 'Lab' ||
        role == 'Result Typing' ||
        role == 'Dispatch' ||
        role == 'Result Printing'
      "
    >
      <mat-expansion-panel hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <img
              class="icon"
              src="assets/icons/Modules/medical-records.svg"
              alt="not"
            />
            <span>Patient</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="allLink">
          <a
            [routerLink]="['/register']"
            *ngIf="role == 'Administrator' || role == 'Front Desk'"
            >Patient Registration</a
          >
          <a [routerLink]="['/patient']">Patients</a>
          <!-- <a [routerLink]="['/encounters']">Encounters</a> -->
          <a
            [routerLink]="['/print-invoice']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            *ngIf="role == 'Administrator' || role == 'Front Desk'"
            >Invoice Print
          </a>
          <!-- <a
            [routerLink]="['/patient-bills']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            *ngIf="role == 'Administrator' || role == 'Front Desk'"
            >Patient Bills
          </a> -->
          <a
            (click)="openLocalPointment()"
            *ngIf="role == 'Administrator' || role == 'Front Desk'"
            >Appointments
          </a>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion
      *ngIf="role == 'Administrator' || role == 'Scan' || role == 'X-ray'"
    >
      <mat-expansion-panel hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <img class="icon" src="assets/icons/Modules/scan.svg" alt="not" />
            <span>Radiology</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="allLink">
          <a
            [routerLink]="['/scan']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            *ngIf="role == 'Administrator' || role == 'Scan'"
            >OBS
          </a>
          <a
            [routerLink]="['/xray']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            *ngIf="role == 'Administrator' || role == 'X-ray' || role == 'Scan'"
            >Scan and Medical IMG
          </a>
          <a
            [routerLink]="['/radiology']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            *ngIf="role == 'Administrator' || role == 'X-ray' || role == 'Scan'"
            >Radiology
          </a>

          <a
            [routerLink]="['/radiology-others']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            *ngIf="
              role == 'Administrator' ||
              role == 'X-ray' ||
              role == 'Scan' ||
              role == 'Radiology'
            "
            >Others
          </a>

          <a
            [routerLink]="['/print-xray']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            *ngIf="role == 'Administrator' || role == 'X-ray' || role == 'Scan'"
            >Print Scan
          </a>
          <a
            [routerLink]="['/radiology-print']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            *ngIf="role == 'Administrator' || role == 'X-ray' || role == 'Scan'"
            >Print Radiology
          </a>
          <a [routerLink]="['/result']">Result Template</a>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion *ngIf="role == 'Administrator' || role == 'Cashier'">
      <mat-expansion-panel hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <img
              class="icon"
              src="assets/icons/Modules/payment.svg"
              alt="not"
            />
            <span>Payment</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="allLink">
          <a
            [routerLink]="['/payment']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            *ngIf="role == 'Administrator' || role == 'Cashier'"
            >Settlement Bill
          </a>
          <a
            [routerLink]="['/ledger']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            *ngIf="role == 'Administrator' || role == 'Cashier'"
            >Bill Ledger
          </a>
          <a
            [routerLink]="['/print-receipt']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            *ngIf="role == 'Administrator' || role == 'Cashier'"
            >Receipt Print
          </a>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion
      *ngIf="
        role == 'Administrator' ||
        role == 'Lab Scientist' ||
        role == 'Lab Supervisor' ||
        role == 'Lab' ||
        role == 'Result Typing' ||
        role == 'Dispatch' ||
        role == 'Result Printing' ||
        role == 'Doctor'
      "
    >
      <mat-expansion-panel hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <img
              class="icon"
              src="assets/icons/Modules/laboratory.svg"
              alt="not"
            />
            <span>Diagnostic</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="allLink">
          <a
            [routerLink]="['/collect-sample']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            *ngIf="role == 'Administrator' || role == 'Lab'"
            >Sample Collection
          </a>
          <a
            [routerLink]="['/acknowledge-sample']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            *ngIf="
              role == 'Administrator' ||
              role == 'Lab Scientist' ||
              role == 'Lab Supervisor'
            "
            >Acknowledge
          </a>
          <a
            [routerLink]="['/encounters']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            *ngIf="
              role == 'Administrator' ||
              role == 'Lab Scientist' ||
              role == 'Lab Supervisor' ||
              role == 'Result Typing'
            "
            >Result Entry
          </a>
          <a
            [routerLink]="['/finalise-encounter']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            *ngIf="role == 'Administrator' || role == 'Doctor'"
            >Result Finalized
          </a>
          <a
            [routerLink]="['/result-print']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            *ngIf="
              role == 'Administrator' ||
              role == 'Dispatch' ||
              role == 'Result Printing' ||
              role == 'Lab Supervisor'
            "
            >Result Print
          </a>
          <a
            [routerLink]="['/result-dispatch']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            *ngIf="
              role == 'Administrator' ||
              role == 'Dispatch' ||
              role == 'Result Printing'
            "
            >Result Dispatch
          </a>
          <a [routerLink]="['/result']">Result Template</a>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion
      *ngIf="
        role == 'Administrator' ||
        role == 'Account' ||
        role == 'Cashier' ||
        role == 'HR'
      "
    >
      <mat-expansion-panel hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <img
              class="icon"
              src="assets/icons/Modules/application.svg"
              alt="not"
            />
            <span>Report</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="allLink">
          <a
            [routerLink]="['/report']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            *ngIf="
              role == 'Administrator' ||
              role == 'Account' ||
              role == 'Cashier' ||
              role == 'HR' ||
              role == 'Front Desk'
            "
            >Report
          </a>
          <a
            [routerLink]="['/export-price']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            *ngIf="role == 'Administrator' || role == 'HR'"
            >Print Price
          </a>
          <a
            [routerLink]="['/export-user']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            *ngIf="role == 'Administrator' || role == 'HR'"
            >Print User
          </a>
          <a
            [routerLink]="['/export-employee']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            *ngIf="role == 'Administrator' || role == 'HR'"
            >Print Employee
          </a>
          <a
            [routerLink]="['/export-dr']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            *ngIf="role == 'Administrator' || role == 'HR'"
            >Print Ref DR
          </a>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <a class="link" [routerLink]="['/password-reset']">
      <img class="icon" src="assets/icons/Modules/settings.svg" alt="" />
      <span>Change Password</span>
    </a>
    <a class="link" [routerLink]="['#']" (click)="logout()">
      <img class="icon" src="assets/icons/Modules/logout.svg" alt="not" />
      <span>Logout</span>
    </a>
  </div>
</mat-nav-list>
